import React from 'react';

import PropTypes from 'prop-types';

import ProductCallout from '~/shared/components/ProductCallout';
import useProductCallout from '~/shared/utils/useProductCallout';

const ProductCardCallout = ({ product }) => {
  // TODO: make a cleaner version of this hook
  // The hook depends on a lot of `availableQuantity` logic that we currently do not have from cio and fedGraph
  // See `getAvailableProductQuantity()` in `useProductCallout.js`
  const callout = useProductCallout({ product, isGridCallout: true });

  if (!product || !callout?.type) {
    return null;
  }

  return <ProductCallout type={callout.type} value={callout.value} />;
};

ProductCardCallout.propTypes = {
  product: PropTypes.shape({
    tagIdList: PropTypes.arrayOf(PropTypes.string),
    membershipBrandId: PropTypes.string,
    waitListAllowed: PropTypes.bool,
    skus: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
      })
    ),
    availableQuantity: PropTypes.number,
    availableQuantityMaster: PropTypes.number,
    productIdObjectList: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
      })
    ),
  }),
};

export default ProductCardCallout;
